import axiosInstance from "./axiosInstance";

export const createTag = async (payload) => {
  try {
    const response = await axiosInstance.post("api/create-tag/", payload);

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to create tag",
      errors: error?.response?.data?.errors || null,
      status: error?.response?.status,
    };
  }
};

export const getTag = async () => {
  try {
    const response = await axiosInstance.get("api/my-tags/");

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to fetch tags",
      status: error?.response?.status,
    };
  }
};

export const updateTag = async (tagId, payload) => {
  try {
    const response = await axiosInstance.put(
      `api/update-tag/${tagId}/`,
      payload
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to update tag",
      errors: error?.response?.data?.errors || null,
      status: error?.response?.status,
    };
  }
};

export const deleteTag = async (tagId) => {
  try {
    const response = await axiosInstance.delete(`api/delete-tag/${tagId}/`);

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to delete tag",
      status: error?.response?.status,
    };
  }
};